import React, { useState, useRef } from 'react';

const PANObject = () => {
  const [formData, setFormData] = useState({
    applicantName: '',
   // acknowledgementNo: '',
    dateOfBirth: '',
    applicationDate: '',
    checkedOption: '', // Default checked option
    remark: '',
    panFile: null,
  });
  const [serverError, setServerError] = useState(""); // Added for API errors
  const fileInputRef = useRef(null);

  const formatDateToString = (date) => {
    if (!date) return '';
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return new Intl.DateTimeFormat('en-GB', options).format(new Date(date)); // Format: dd/MM/yyyy
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === 'file') {
      setFormData({ ...formData, panFile: files[0] });
    } else if (type === 'checkbox') {
      setFormData({ ...formData, checkedOption: checked ? value : '' });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const [showConfirmModal, setShowConfirmModal] = useState(false);

const [successMsg, setSuccessMsg] = useState("");

  const handleFormSubmit = (e) => {
  e.preventDefault();
  setServerError("");
  setShowConfirmModal(true); // Only show modal, do not submit yet
};

const handleStay = () => {
  setShowConfirmModal(false);
};


const handleConfirm = async () => {
  setShowConfirmModal(false); // Hide modal

   //const apiEndpoint = 'http://localhost:5121/api/PanObject/PanObject';
    const apiEndpoint = 'https://apiv2.chakran.in/api/PanObject/PanObject'; 
    const formDataToSend = new FormData();

    // Append form data
    formDataToSend.append('ApplicantName', formData.applicantName);
    //formDataToSend.append('AcknowledgementNo', formData.acknowledgementNo);
    formDataToSend.append('DateOfBirth', formatDateToString(formData.dateOfBirth)); // Format: dd/MM/yyyy
    formDataToSend.append('ApplicationDate', formatDateToString(formData.applicationDate)); // Format: dd/MM/yyyy
    formDataToSend.append('CheckedOption', formData.checkedOption);
    formDataToSend.append('Remark', formData.remark);
    formDataToSend.append('PANFilePath', formData.panFile);

    const authToken = localStorage.getItem("authToken");

    try {
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        body: formDataToSend,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.ok) {
        alert('Application submitted successfully!');     
        // Trigger balance update
        window.dispatchEvent(new Event("balanceUpdated"));
        setFormData({
          applicantName: '',
         // acknowledgementNo: '',
          dateOfBirth: '',
          applicationDate: '',
          checkedOption: '',
          remark: '',
          panFile: null,
        });
        // ✅ Clear file input from DOM
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        
      } else {
        alert('Failed to submit the application. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting the application:', error);
      alert('An error occurred while submitting the application.');
      setServerError(error.message);
    }
  };

  return (
    <>
      
          <form onSubmit={handleFormSubmit}>
            <div className="card card-default">
              <div className="card-body">
                <div className="row">
                  <div className="form-group col-md-2">
                    <label htmlFor="applicantName">Applicant Name</label>
                  </div>
                  <div className="form-group col-md-2">
                    <input
                      type="text"
                      className="form-control"
                      id="applicantName"
                      name="applicantName"
                      value={formData.applicantName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  {/* <div className="form-group col-md-3">
                    <label htmlFor="acknowledgementNo">Acknowledgement No</label>
                  </div>
                  <div className="form-group col-md-3">
                    <input
                      type="text"
                      className="form-control"
                      id="acknowledgementNo"
                      name="acknowledgementNo"
                      value={formData.acknowledgementNo}
                      onChange={handleChange}
                      required
                    />
                  </div> */}
                  <div className="form-group col-md-2">
                    <label htmlFor="dateOfBirth">Date Of Birth</label>
                  </div>
                  <div className="form-group col-md-2">
                    <input
                      type="date"
                      className="form-control"
                      id="dateOfBirth"
                      name="dateOfBirth"
                      value={formData.dateOfBirth}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group col-md-2">
                    <label htmlFor="applicationDate">Application Date</label>
                  </div>
                  <div className="form-group col-md-2">
                    <input
                      type="date"
                      className="form-control"
                      id="applicationDate"
                      name="applicationDate"
                      value={formData.applicationDate}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="form-check d-inline-block mb-3 col-md-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="name"
                      name="checkedOption"
                      value="Name"
                      checked={formData.checkedOption === 'Name'}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="name">
                      Name
                    </label>
                  </div>
                  <div className="form-check d-inline-block mb-3 col-md-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="fathersName"
                      name="checkedOption"
                      value="FathersName"
                      checked={formData.checkedOption === 'FathersName'}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="fathersName">
                      Fathers Name
                    </label>
                  </div>
                  <div className="form-check d-inline-block mb-3 col-md-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="other"
                      name="checkedOption"
                      value="Other"
                      checked={formData.checkedOption === 'Other'}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="other">
                      Other
                    </label>
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-md-2">
                    <label htmlFor="remark">Remark</label>
                  </div>
                  <div className="form-group col-md-10">
                    <textarea
                      className="form-control"
                      id="remark"
                      name="remark"
                      value={formData.remark}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-md-3">
                    <label htmlFor="panFile">Upload PAN Application File</label>
                  </div>
                  <div className="form-group col-md-9">
                    <input
                      type="file"
                      className="form-control"
                      id="panFile"
                      name="panFile"
                      ref={fileInputRef}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="form-footer pt-5 text-center">
                <p>Note: Form Submition Charges Rs.350</p>
                  <button type="submit" className="btn btn-primary btn-pill">
                    Submit
                  </button>
                </div>
              </div>
            </div>
            {/* 🔴 Display server error if it exists */}
            {serverError && <div className="alert alert-danger">{serverError}</div>}
            {successMsg && <div className="alert alert-success">{successMsg}</div>}
          </form>
          {showConfirmModal && (
      <div className="modal-backdrop" style={{
        position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
        background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999
      }}>
        <div style={{
          background: "#fff", padding: 24, borderRadius: 8, minWidth: 300, textAlign: "center"
        }}>
          <h5>Do you want to submit?</h5>
          <p>Press Confirm to submit or Stay to remain on this page.</p>
          <button className="btn btn-secondary mr-2" onClick={handleStay}>Stay</button>
          <button className="btn btn-primary" onClick={handleConfirm}>Confirm</button>
        </div>
      </div>
    )}
    </>
  );
};

export default PANObject;


